import {
    BannersEditMassActions,
    CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_KEY_OR_VALUE_SELECT,
    CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_NEW_PARAMETERS,
    CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_SITE_LINKS_TUMBLER,
    CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_TARGET_PARAMETERS,
    CLOSE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR,
    ON_ACCEPT_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR,
    OPEN_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR
} from '../../../actions/banners-edit/banners-edit-mass-actions';
import { BannersEditMassActionsState } from '../../../typings/bannersEditState';
import { State } from '../../../typings/state';

import { bannersEditMassActionsInitialState } from './banners-edit-mass-actions';

export function bannersEditMassActionsTrackingParametersReplaceReducer(
    state: BannersEditMassActionsState = bannersEditMassActionsInitialState,
    action: BannersEditMassActions,
    fullState: State
): BannersEditMassActionsState {
    switch (action.type) {
        case OPEN_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    visibleModalActions: {
                        ...state[action.massActionId].visibleModalActions,
                        linkTrackingParametersBulkReplacementEditorVisible: true
                    }
                }
            };

        case ON_ACCEPT_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR:
        case CLOSE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_REPLACEMENT_EDITOR:
            return bannersEditMassActionsInitialState;

        case CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_SITE_LINKS_TUMBLER:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        isSiteLinksTumblerChecked: !state[action.massActionId].data.isSiteLinksTumblerChecked
                    }
                }
            };

        case CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_KEY_OR_VALUE_SELECT:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        keyOrValueReplacement: action.keyOrValueReplacement
                    }
                }
            };

        case CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_TARGET_PARAMETERS:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        targetParameters: action.targetParameters
                    }
                }
            };

        case CHANGE_MASS_ACTIONS_TRACKING_PARAMETERS_BULK_NEW_PARAMETERS:
            return {
                ...state,
                [action.massActionId]: {
                    ...state[action.massActionId],
                    data: {
                        ...state[action.massActionId].data,
                        newParameters: action.newParameters
                    }
                }
            };

        default:
            return state;
    }
}
